"use strict";

export function get_gallery_class_name(is_special_shop) {
    if (is_special_shop) {
        return 'gallery-prd-name-span';
    } else {
        return 'MSH-display-none';
    }
}

export function get_gallery_class_price(is_special_shop) {
    if (is_special_shop) {
        return 'gallery-price-span';
    } else {
        return 'MSH-display-none';
    }
}

export function get_gallery_class_state(is_special_shop) {
    if (is_special_shop) {
        return 'gallery-prd-state-span';
    } else {
        return 'sale-state-bar';
    }
}
